import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=e6e4c4f2&"
import script from "./ModelForm.vue?vue&type=script&lang=js&"
export * from "./ModelForm.vue?vue&type=script&lang=js&"
import style0 from "./ModelForm.vue?vue&type=style&index=0&id=e6e4c4f2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports